// extracted by mini-css-extract-plugin
export default {"locationIcon":"merchantInformation_locationIcon__tehm1"};